import { memo } from 'react';
import { MdPlayCircleOutline } from 'react-icons/md';
import type { MediaItem } from '../types';

type MediaTileProps = {
  item: MediaItem;
  onClick?: () => void;
};

export const MediaTile = memo(({ item, onClick }: MediaTileProps) => {
  const thumb = item.thumbUrl || item.url;

  return (
    <button
      type="button"
      className="relative aspect-square w-full overflow-hidden rounded-sm bg-base-70 cursor-pointer"
      onClick={onClick}
    >
      <img src={thumb} alt="" loading="lazy" className="w-full h-full object-cover" />
      {item.type === 'video' && (
        <div className="absolute inset-0 flex items-center justify-center bg-black/20">
          <MdPlayCircleOutline className="text-white drop-shadow" size={28} />
        </div>
      )}
    </button>
  );
});
